export const setCurrentPage = '@notification/setCurrentPage';
export const setItemsPerPage = '@notification/setItemsPerPage';
export const setNotificationItems = '@notification/setNotificationItems';
export const setPaginationMeta = '@notification/setPaginationMeta';
